import React, { useContext } from "react";
import styles from "../side.module.scss";
import { menuIconFig, ROUTES } from "../../../../../constant";
import { BRAND_NAME } from "../../../../../constant/common";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { useMobileNavBookButtonVariant } from "../../../../../experiments";
import HeaderNavTitle from "../../../../reusableComponent/headerNavTitle/HeaderNavTitle";
import { getChatTitle } from "../../../../../utils/chat/chatTitle";
import { isAdminUser } from "../../../../../utils/isAdminUser";

interface MobileNavBarProps {
  navBarStyles: React.CSSProperties;
  toggleSidebar: () => void;
  isAdminChat: boolean;
  userInfo: any;
  pathname: string;
  currentHistoryId: string;
  handleCopy: () => void;
  handleBook: () => void;
  isWeatherAdvisory?: boolean;
}

const MobileNavBar: React.FC<MobileNavBarProps> = ({
  navBarStyles,
  toggleSidebar,
  isAdminChat,
  userInfo,
  pathname,
  currentHistoryId,
  handleCopy,
}) => {
  useMobileNavBookButtonVariant();
  const { chatData }: iGlobalContext = useContext(StateContext);
  const currentChatTitle =
    getChatTitle(chatData) ||
    chatData?.find((entry: any) => entry?.isUserMessage && entry?.message && !entry?.shouldNotShowFirstMessage)
      ?.message ||
    "";
  const headerLabel = currentChatTitle || BRAND_NAME;
  const showHistoryId = isAdminUser(userInfo) && isAdminChat && pathname.startsWith(ROUTES.TopDestination);
  return (
    <div className={styles.navBar} style={navBarStyles}>
      <HeaderNavTitle
        bare
        leftIcon={menuIconFig}
        leftIconSize={12}
        onLeftClick={toggleSidebar}
        title={headerLabel}
        rightNode={
          showHistoryId ? (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a id="copyText" className={styles.historyIdCopy} onClick={handleCopy}>
              {currentHistoryId}
            </a>
          ) : undefined
        }
      />
    </div>
  );
};

export default MobileNavBar;
